import React from "react";
import { useSearchParams } from "react-router-dom";
import { useSiteData, waLink } from "../lib/hooks";
import { fileUrl } from "../lib/api";
import { Reveal, Overline } from "../components/site/Reveal";
import PageHeader from "../components/site/PageHeader";
import EnquiryForm from "../components/site/EnquiryForm";
import { MapPin, Phone, Mail } from "lucide-react";

const IMG = (s, k) => fileUrl(s?.images?.[k]);

export default function Contact() {
  const s = useSiteData();
  const [params] = useSearchParams();
  const pkg = params.get("package");
  return (
    <div>
      <PageHeader overline="Contact & Enquiry" title={<>Let's plan your <span className="italic gold-text">occasion.</span></>}
        subtitle="Share your details and our catering team will build the experience around it." image={IMG(s, "spread")} />

      <section className="py-24 bg-ivory">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Reveal>
              <Overline>Reach Us</Overline>
              <h2 className="font-serif text-burgundy text-4xl mt-4 mb-8">We'd love to hear from you.</h2>
              <div className="space-y-6">
                {[[MapPin, "Visit", s.address || "Hyderabad, India"],
                  [Phone, "Call", s.phone || "+91 93812 05545"],
                  [Mail, "Email", s.email || "hello@foodieconnectcaterer.com"]].map(([Icon, label, val]) => (
                  <div key={label} className="flex items-start gap-4">
                    <span className="w-12 h-12 rounded-full border border-gold/40 flex items-center justify-center shrink-0"><Icon className="w-5 h-5 text-gold" /></span>
                    <div><p className="overline">{label}</p><p className="text-charcoal/80 mt-1">{val}</p></div>
                  </div>
                ))}
              </div>
              <a href={waLink(s)} target="_blank" rel="noreferrer" className="btn-gold mt-8" data-testid="contact-whatsapp"><i className="fa-brands fa-whatsapp" /> Chat on WhatsApp</a>
            </Reveal>
          </div>
          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <div className="bg-cream border border-gold/20 rounded-3xl p-6 sm:p-10">
                <h3 className="font-serif text-3xl text-burgundy mb-6">Request a Catering Quote</h3>
                <EnquiryForm preset={pkg ? { category: "MENU ENQUIRY", menu_ref: pkg, message: `Interested in the ${pkg} package.` } : {}} />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
